import axios from "axios";
import { baseUrl, config, requestID } from "./utils";

// src/services/api.js (add to your existing file)
export const deviceApi = {
  // Check if device is registered

   
  checkDeviceRegistration_kil: async (userId, deviceHash) => {
    try {
      const response = await fetch('/api/device/check', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          user_id: userId,
          device_hash: deviceHash
        })
      });
      
      return await response.json();
    } catch (error) {
      return {
        success: false,
        message: 'Network error checking device00'
      };
    }
  },
   checkDeviceRegistration: async (userId, deviceHash,deviceCode) => {
      const data = {
          requestID: requestID(),
          user_id: userId,
          device_hash: deviceHash,
          device_code:deviceCode
      };
      console.log({ data })
      try {
          const response = await axios.post(
              baseUrl() + "devices/checkDevice",
              data,
              config
          );
          console.log({ response })
          return response.data
  
      } catch (error: any) {
          return error
      }
  
  },
    deactivateDevice: async (id,user_id) => {
      const data = {
          requestID: requestID(),
          device_id:id,
          user_id:user_id
      };
      console.log({ data })
      try {
          const response = await axios.post(
              baseUrl() + "devices/deactivateDevice",
              data,
              config
          );
          console.log({ response })
          return response.data
  
      } catch (error: any) {
          return error
      }
  
  },
    getAllDevices: async () => {
      const data = {
          requestID: requestID(),
      };
      try {
          const response = await axios.post(
              baseUrl() + "devices/getAllDevices",
              data,
              config
          );
          console.log({ response })
          return response.data
  
      } catch (error: any) {
          return error
      }
  
  },
  
  // Get user's registered devices
  getUserDevices: async (userId) => {
    try {
      const response = await fetch(`/api/user/devices?user_id=${userId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      
      return await response.json();
    } catch (error) {
      return {
        success: false,
        message: 'Network error fetching devices'
      };
    }
  },


    // Get user's registered devices
  getAllDevices_kil: async () => {
    try {
      const response = await fetch(`/api/user/devices?user_id=${userId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      
      return await response.json();
    } catch (error) {
      return {
        success: false,
        message: 'Network error fetching devices'
      };
    }
  },
    registerDevice: async (userId, deviceCode, deviceName = '') => {
      const data = {
          requestID: requestID(),
          user_id: userId,
          device_code: deviceCode,
          device_name: deviceName
      };
      try {
          const response = await axios.post(
              baseUrl() + "devices/registerDevice",
              data,
              config
          );
          console.log({ response })
          return response.data
  
      } catch (error: any) {
          return error
      }
  
  },
  
  // Admin: Register a device
  registerDevice_kil: async (userId, deviceCode, deviceName = '') => {
    try {
      const response = await fetch('/api/admin/device/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          user_id: userId,
          device_code: deviceCode,
          device_name: deviceName
        })
      });
      
      return await response.json();
    } catch (error) {
      return {
        success: false,
        message: 'Network error registering device90'
      };
    }
  }
};